// redux
import { combineReducers, createStore } from 'redux';
import { devToolsEnhancer } from 'redux-devtools-extension';
// reducers
import SHARE_DATA from './shareData';

const rootReducer = combineReducers({
  SHARE_DATA,
});

const store = createStore(rootReducer, devToolsEnhancer({}));
export type Istore = ReturnType<typeof rootReducer>;

export default store;
